var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.languages !== '')?_c('div',_vm._l((_vm.languages),function(lang,i){return _c('span',{key:lang,staticClass:"language"},[_vm._v(" "+_vm._s(i === _vm.languages.length - 1 ? lang : `${lang},`)+" ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }